import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

const LABEL = {
  dashboard: "Dashboard", crm: "CRM / Leads", customers: "Customers", quotations: "Quotations",
  proformas: "Proforma Invoices", invoices: "Invoices", purchase_orders: "Purchase Orders",
  inventory: "Inventory", analytics: "Analytics", staff: "Staff Management", settings: "Admin Settings",
};

export const PermissionMatrix = ({ modules = [], actions = [], value = {}, onChange }) => {
  const toggle = (mod, act) => {
    const cur = value[mod] || [];
    const next = cur.includes(act) ? cur.filter((a) => a !== act) : [...cur, act];
    onChange({ ...value, [mod]: next });
  };

  const toggleAll = (mod) => {
    const cur = value[mod] || [];
    onChange({ ...value, [mod]: cur.length === actions.length ? [] : [...actions] });
  };

  return (
    <div className="scroll-slim overflow-x-auto rounded-lg border border-border">
      <table className="w-full min-w-[720px] text-sm">
        <thead>
          <tr className="border-b border-border bg-muted/50">
            <th className="px-3 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">Module</th>
            {actions.map((a) => (
              <th key={a} className="px-2 py-2.5 text-center text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{a}</th>
            ))}
            <th className="px-3 py-2.5 text-right text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">All</th>
          </tr>
        </thead>
        <tbody>
          {modules.map((m) => (
            <tr key={m} className="border-b border-border/60 last:border-0">
              <td className="px-3 py-2 font-medium">{LABEL[m] || m}</td>
              {actions.map((a) => (
                <td key={a} className="px-2 py-2 text-center">
                  <Checkbox
                    checked={(value[m] || []).includes(a)}
                    onCheckedChange={() => toggle(m, a)}
                    data-testid={`perm-${m}-${a}`}
                  />
                </td>
              ))}
              <td className="px-3 py-2 text-right">
                <button type="button" onClick={() => toggleAll(m)}
                  className={cn("text-xs font-medium hover:underline",
                    (value[m] || []).length === actions.length ? "text-destructive" : "text-primary")}>
                  {(value[m] || []).length === actions.length ? "Clear" : "Select all"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
